import Api from 'src/api/Base'

class UpdateSpaceAssignmentById extends Api {
  requestUrl = `/api/SpaceAssignment/${this.getParams().id}`

  method = 'PATCH'
}

export default UpdateSpaceAssignmentById
